import { Component, OnInit, OnDestroy, ViewChild, TemplateRef } from '@angular/core';
import { Router } from '@angular/router';

import { BsModalService, BsModalRef, ModalOptions } from 'ngx-bootstrap/modal';

import { ApiResponseModel } from 'app/_models/apiResponseModel';
import { Globals } from 'app/_models/globals';
import { NotificationQuotation, NotificationQuotationItem } from 'app/_models/notificationQuotation';

import { BuyerPecasCanceladasService } from './pecas-canceladas.service';
import { BuyerSignalRService } from '../../_services/buyer.signalr.service';
import { PartsfyNotificationService } from 'app/general/_services/partsfy-notification.service';
import { NotificationService } from 'app/_services/notification.service';
import { SettingsService } from 'app/_services/settings.service';
import { Subscription } from 'rxjs';
import { UserService } from 'app/_services/user.service';

declare const $: any;
declare const isEmpty: any;

@Component({
    selector: 'app-pecas-canceladas', templateUrl: './pecas-canceladas.component.html', styleUrls: ['./pecas-canceladas.component.scss'],
    standalone: false
})
export class BuyerPecasCanceladasComponent implements OnInit, OnDestroy {
    @ViewChild('template') template: TemplateRef<any>;
    modalRef: BsModalRef;

    loading: boolean = false;
    notificacaoSelecionada: any;
    pecasSelecionadas: string[];

    private subscriptionNotification: Subscription;
    private subscriptionAtualizarNotificacoesComprador: Subscription;

    constructor(
        public userService: UserService,
        private buyerPecasCanceladasService: BuyerPecasCanceladasService,
        private buyerSignalRService: BuyerSignalRService,
        private notificationService: NotificationService,
        private partsfyNotificacaoService: PartsfyNotificationService,
        public settingService: SettingsService,
        private globals: Globals,
        private modalService: BsModalService,
        private router: Router) {
        this.notificacaoSelecionada = {};
        this.pecasSelecionadas = [];
    }

    ngOnInit() {
        this.registerObservables();
        this.listarNotificacoes();

        this.subscriptionNotification = this.partsfyNotificacaoService.notificacaoSelecionada.subscribe(notificacao => {
            this.notificacaoSelecionada = notificacao;

            if (!isEmpty(this.notificacaoSelecionada)) {
                this.listarNotificacoesPecas(notificacao.id, notificacao.seller_company_id);

                let options: ModalOptions = { backdrop: 'static', class: 'gray modal-lg', keyboard: false };
                this.modalRef = this.modalService.show(this.template, options);
            }
        });
    }

    ngOnDestroy() {
        this.subscriptionNotification.unsubscribe();
        this.subscriptionAtualizarNotificacoesComprador.unsubscribe();
    }

    async atualizarNotificacao(status: number, nAttempts: number) {
        let originalStatus = status;

        if (isEmpty(this.notificacaoSelecionada)) {
            this.modal_fechar();
            return;
        }

        var resposta = false;

        if (status == 1) {
            resposta = await this.notificationService.showConfirmationDialog('buyer.pecas-canceladas.mensagens.atualizar.confirm.ignorar');
            this.pecasSelecionadas = this.notificacaoSelecionada.parts.map(part => part.item_id)
        } else if (status == 3) {
            resposta = await this.notificationService.showConfirmationDialog('buyer.pecas-canceladas.mensagens.atualizar.confirm.recomprar');
            this.pecasSelecionadas = this.notificacaoSelecionada.parts.map(part => part.item_id)
            status = 1;
        } else {
            if (this.pecasSelecionadas.length == 0) {
                alert(this.globals.translate('buyer.pecas-canceladas.mensagens.sem-pecas-selecionadas'));
                return;
            }

            resposta = await this.notificationService.showConfirmationDialog('buyer.pecas-canceladas.mensagens.atualizar.confirm.cancelar');
        }

        if (!resposta) return;

        this.loading = true;

        this.buyerPecasCanceladasService.updateNotification(this.notificacaoSelecionada.id, this.pecasSelecionadas, status).subscribe({
            next: () => {
                this.loading = false;
                this.modal_fechar();

                setTimeout(() => {
                    this.buyerSignalRService.AtualizarDashboardCompradorEvent.emit()

                    if (originalStatus == 3) {
                        this.router.navigate(['/comprador/mercado'], { queryParams: { montadora: this.notificacaoSelecionada.parts[0].brand_id } })
                    }
                }, 500);

                this.listarNotificacoes();
            },
            error: error => {
                nAttempts = nAttempts || 1;
                console.log(error, nAttempts);

                if (nAttempts >= 5) {
                    this.loading = false;
                    this.modal_fechar();
                    this.notificationService.showErrorToastr(this.globals.translate('buyer.pecas-canceladas.mensagens.erro-atualizar.corpo'));
                    return;
                }

                this.atualizarNotificacao(status, ++nAttempts);
            }
        });
    }

    listarNotificacoes() {
        this.buyerPecasCanceladasService.getAllNotifications().subscribe({
            next: (response: ApiResponseModel<{ notifications: NotificationQuotation[] }>) => {
                if (response && response.success) {
                    this.partsfyNotificacaoService.atualizarNotifications(response.result.notifications);
                }
            },
            error: error => {
                console.log(error);
            }
        });
    }

    listarNotificacoesPecas(notificationOrderInfoId: number, sellerCompanyId: number) {
        this.loading = true;
        this.pecasSelecionadas = [];

        this.buyerPecasCanceladasService.getAllNotificationItems(notificationOrderInfoId, sellerCompanyId).subscribe({
            next: (response: ApiResponseModel<{ parts: NotificationQuotationItem[] }>) => {
                if (response && response.success && !isEmpty(this.notificacaoSelecionada)) {
                    this.notificacaoSelecionada.parts = response.result.parts;
                }

                this.loading = false;
            },
            error: error => {
                console.log(error);
                this.loading = false;
            }
        });
    }

    modal_fechar() {
        this.modalRef.hide();
    }

    notificacao_habilitaReabrir() {
        return this.pecasSelecionadas.length > 0;
    }

    notificacao_selecionarPeca(peca: NotificationQuotationItem, $event) {
        if ($($event.target).is(":checked")) {
            this.pecasSelecionadas.push(peca.item_id.toString());
        }
        else {
            this.pecasSelecionadas = this.pecasSelecionadas.filter(p => p != peca.item_id.toString())
        }
    }

    notificacao_selecionarTodasPecas($event) {
        let is_checked = $($event.target).is(":checked");

        this.notificacaoSelecionada.parts.forEach(peca => {
            if (is_checked) {
                this.pecasSelecionadas.push(peca.item_id);
            }
            else {
                this.pecasSelecionadas = this.pecasSelecionadas.filter(p => p != peca.item_id)
            }
        });

        $('.peca_notificacao').prop("checked", is_checked);
    }


    registerObservables() {
        this.subscriptionAtualizarNotificacoesComprador = this.buyerSignalRService.AtualizarNotificacoesComprador.subscribe(data => {
            data = JSON.parse(data.toString())

            var notificacao = {
                id: data.id, order_id: data.order_id, buyer_company_id: data.buyer_company_id, repairer_name: data.repairer_name, seller_company_id: data.seller_company_id, subject: data.subject,
                message: data.message, status_id: data.status_id, veiculo: data.veiculo
            };

            if (!isEmpty(notificacao)) {
                this.partsfyNotificacaoService.adicionarNotification(notificacao);
            }
        });
    }
}
